import type { FaireProductEntity } from "../../entity_types/product";

export const p_gby6j69z3q: FaireProductEntity = {
  token: "p_gby6j69z3q",
  type: "product",
  name: "Mini Hand Care Duo Boxed Set",
  brandName: "PAUME",
  imageUrl:
    "https://cdn.faire.com/fastly/44a8fd96f9a5844bd2c712afc5c5e951c965803bb2ebf6825e2a0a48ac8a7108.png",
  priceDollars: 11,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7e7d68bfb16ee168a77ef08ab66c4a9480c721303effa1124bd08d5df27388d8.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
